import apis from "../../utils/apis"
import { showFeedbackModal } from "./UserFeedbackActions"
import { SET_EXTERNAL_ACCOUNTS } from "../types";
import { hideModal, showModal } from "./modalActions";
import { handleApiError } from "./utils/utils";
import { translate } from '../../i18n/translate';

export const setExternalAccounts = (external_accounts: any[]) => {
    return {
        type: SET_EXTERNAL_ACCOUNTS,
        external_accounts,
    };
};


export const createConnectedAccount = (Token?: string | "") => {
    return async (dispatch: any) => {
        try {

            const resp = await apis({
                method: 'POST',
                url: "/payments/accounts/create",
                data: {
                    Token
                }
            })

            if (resp && resp.status === 200) {
                dispatch(showFeedbackModal({
                    showModal: true,
                    message: resp.data.message,
                    modalType: 'success',
                    duration: 3000
                }));
                return resp.data

            } else {
                 handleApiError(resp, dispatch)
                 return null
            }
        } catch (err) {
            handleApiError(err, dispatch)
            return null
        }
    }
}

export const listRecieversAccount = (CustomerID: string) => {
    return async (dispatch: any) => {
        try {

            const resp: any = await apis({
                method: 'POST',
                url: "/payments/accounts/list",
                data: {
                    CustomerID: CustomerID,
                }
            })

            if (resp && resp.status === 200) {
                const accounts = resp.data.user_accounts
                if (accounts && accounts.length > 0) {
                    if (accounts[0].account_info.Details_submitted) {
                        dispatch(setExternalAccounts(accounts[0].external_accounts))
                    } else {
                        dispatch(setExternalAccounts([accounts[0].account_info]))
                    }
                } else {
                    dispatch(setExternalAccounts([]))
                }
                return resp.data
            } else {
                handleApiError(resp, dispatch)
            }

        } catch (err) {
            handleApiError(err, dispatch)
        }
    }
}

export const createVerificationSession = (CustomerID: string) => {
    return async (dispatch: any) => {
        try {

            const resp = await apis({
                method: 'POST',
                url: "/payments/verification/initiate",
                data: {
                    CustomerID
                }
            })

            if (resp && resp.status === 200) {
                dispatch(showFeedbackModal({
                    showModal: true,
                    message: (resp.data?.message),
                    modalType: 'success',
                    duration: 3000
                }));
                return resp.data

            }
            else {
                handleApiError(resp, dispatch)
            }

        } catch (err) {
            handleApiError(err, dispatch)
        }
    }
}

export const createCheckoutSession = (licenseId: string, country: string | null, quantity: number) => {
    return async (dispatch: any) => {


        try {
            const resp = await apis({
                method: 'POST',
                url: "/payments/checkout/session",
                
                data: {
                    licenseId: licenseId,
                    coj: country,
                    quantity: quantity
                  },
            })

            if (resp && resp.status === 200) {
                return resp.data
            }
            else {
                handleApiError(resp, dispatch)
            }

        } catch (err) {
            handleApiError(err, dispatch)
        }
    }
}

export const createAccountLink = (AccountID: string) => {
    return async (dispatch: any) => {
        try {

            const resp = await apis({
                method: 'POST',
                url: "/payments/accounts/onboarding-link",
                data: {
                    AccountID,
                }
            })

            if (resp && resp.status === 200) {
                dispatch(showFeedbackModal({
                    showModal: true,
                    message: resp.data.message,
                    modalType: 'success',
                    duration: 3000
                }));
                return resp.data

            } else {
                handleApiError(resp, dispatch)
            }
        } catch (err) {
            handleApiError(err, dispatch)
        }
    }
}

export const createPaymentSession = (CaseID: string, LawyerID: string, ClientEmail: string) => {
    return async (dispatch: any) => {


        try {
            const resp = await apis({
                method: 'POST',
                url: "/payments/checkout/direct-session",
                data: {
                    CaseID,
                    LawyerID,
                    ClientEmail
                }
            })

            if (resp && resp.status === 200) {
                if (resp.data.session) {
                    dispatch(showModal({
                        type: "redirect",
                        message: translate("You are being redirected to stripe. Please wait..."),
                        onConfirm: () => { },
                        onCancel: () => hideModal(),
                        showModal: true,
                    }))
                    window.location.href = resp.data.session;
                }
            }
            else {
                handleApiError(resp, dispatch)
            }

        } catch (err) {
            handleApiError(err, dispatch)
        }
    }
}


export const fetchCaseDeposit = (CaseID: string) => {
    return async (dispatch: any) => {


        try {
            const resp = await apis({
                method: 'POST',
                url: "/payments/checkout/fetch-deposit",
                data: {
                    CaseID,
                }
            })

            if (resp && resp.status === 200) {
                return resp.data
            }
            else {
                handleApiError(resp, dispatch)
            }

        } catch (err) {
            handleApiError(err, dispatch)
        }
    }
}


export const createDepositePaySession = (CaseID: string, DepositeID: string, ClientEmail: string) => {
    return async (dispatch: any) => {


        try {
            const resp = await apis({
                method: 'POST',
                url: "/payments/checkout/pay-deposit",
                data: {
                    CaseID,
                    DepositeID,
                    ClientEmail
                }
            })

            if (resp && resp.status === 200) {
                if (resp.data.session) {
                    dispatch(showModal({
                        type: "redirect",
                        message: translate("You are being redirected to stripe. Please wait..."),
                        onConfirm: () => { },
                        onCancel: () => hideModal(),
                        showModal: true,
                    }))
                    window.location.href = resp.data.session;
                }
            }
            else {
                handleApiError(resp, dispatch)
            }

        } catch (err) {
            handleApiError(err, dispatch)
        }
    }
}
